import React, { useState } from 'react';
import { 
  FaChevronDown,
  FaChevronUp,
  FaQuestionCircle,
  FaGraduationCap,
  FaHome,
  FaPassport,
  FaFileInvoiceDollar,
  FaUserCheck,
  FaStar
} from 'react-icons/fa';
import './FAQSection.css';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "Combien de temps prend le processus d'admission ?",
      answer: "Le processus d'admission varie entre 2 à 4 mois selon l'établissement et la période de l'année. Nous optimisons chaque étape pour réduire les délais au maximum.",
      icon: <FaGraduationCap />,
      category: "Admission",
      color: '#073b8f'
    },
    {
      question: "Quels sont les délais pour l'obtention du visa étudiant ?",
      answer: "Après l'obtention de votre admission, le visa étudiant prend généralement 2 à 3 semaines. Nous vous accompagnons dans la préparation de tous les documents requis.",
      icon: <FaPassport />,
      category: "Visa",
      color: '#c0264a'
    },
    {
      question: "Comment trouvez-vous des logements pour les étudiants ?",
      answer: "Nous disposons d'un réseau de résidences étudiantes partenaires dans toute la France. Nous garantissons un logement adapté à votre budget et proche de votre établissement.",
      icon: <FaHome />,
      category: "Logement",
      color: '#073b8f'
    },
    {
      question: "Qu'est-ce que l'AVI et comment l'obtenir ?",
      answer: "L'AVI (Attestation de Virement Irrévocable) est une preuve de ressources obligatoire. Nous facilitons son obtention auprès d'établissements financiers partenaires.",
      icon: <FaFileInvoiceDollar />,
      category: "Finance",
      color: '#c0264a'
    },
    {
      question: "Proposez-vous un accompagnement après l'arrivée en France ?",
      answer: "Oui ! Notre accompagnement continue après votre arrivée : installation, ouverture de compte bancaire, validation de visa, et suivi académique.",
      icon: <FaUserCheck />,
      category: "Accompagnement",
      color: '#073b8f'
    },
    {
      question: "Quels sont vos frais de service ?",
      answer: "Nos tarifs sont transparents et adaptés à chaque projet. Nous proposons différents packages selon vos besoins. Contactez-nous pour une étude personnalisée gratuite.",
      icon: <FaQuestionCircle />,
      category: "Tarifs",
      color: '#c0264a'
    },
    {
      question: "Quelle est votre taux de réussite pour les visas ?",
      answer: "Nous maintenons un taux de réussite de 95% grâce à notre expertise des dossiers et notre préparation minutieuse de chaque candidature.",
      icon: <FaStar />,
      category: "Réussite",
      color: '#073b8f'
    },
    {
      question: "Puis-je venir avec ma famille ?",
      answer: "Oui, nous accompagnons également les étudiants qui souhaitent venir avec leur conjoint et/ou enfants, avec des solutions adaptées pour chaque situation familiale.",
      icon: <FaUserCheck />,
      category: "Famille",
      color: '#c0264a'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="btg-faq-section-dark" id="btg-faq">
      <div className="btg-container-dark">
        {/* En-tête de section - Style sombre premium */}
        <div className="btg-faq-header-dark">
          <div className="btg-header-content-dark">
            <div className="btg-header-badge">
              <FaQuestionCircle className="btg-badge-icon" />
              <span>Questions Fréquentes</span>
            </div>
            <h1 className="btg-main-title-dark">Vos questions</h1>
            <p className="btg-main-subtitle-dark">Nos réponses claires</p>
            <p className="btg-section-subtitle-dark">
              Tout ce que vous devez savoir sur votre projet d'études en France
            </p>
            <div className="btg-header-decoration-dark">
              <div className="btg-decoration-line-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-glow-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-line-dark"></div>
            </div>
          </div>
        </div>

        {/* Section FAQ principale */}
        <div className="btg-faq-content-dark">
          <div className="btg-faq-grid-dark">
            <div className="btg-faq-main-dark">
              {faqItems.map((item, index) => (
                <div 
                  key={index} 
                  className={`btg-faq-item-dark ${activeIndex === index ? 'btg-active-dark' : ''}`}
                  onClick={() => toggleFAQ(index)}
                  style={{ '--btg-accent-color': item.color }}
                >
                  <div className="btg-faq-question-dark">
                    <div className="btg-faq-question-content-dark">
                      <div className="btg-faq-icon-dark">
                        {item.icon}
                      </div>
                      <h3 className="btg-faq-question-text-dark">
                        {item.question}
                      </h3>
                    </div>
                    <div className="btg-faq-arrow-dark">
                      {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>
                  
                  <div className="btg-faq-answer-dark">
                    <div className="btg-faq-answer-content-dark">
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
      </div>
    </section>
  );
};

export default FAQSection;